<app-outage></app-outage>
<router-outlet></router-outlet>
